var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "sy_copy", staticStyle: { position: "relative" } },
      [
        _c(
          "div",
          {
            staticStyle: {
              width: "150px",
              position: "absolute",
              left: "4px",
              top: "25px",
              "z-index": "9",
              display: "none"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("../assets/img/mobile_code.png"),
                width: "145"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "xinguanfeiyan2", staticStyle: { display: "none" } },
          [
            _c("img", {
              attrs: {
                src: require("../assets/img/xinguan2.png"),
                width: "145"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sy_copy_nav" }, [
          _c("ul", [
            _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("邮件服务")])]),
            _vm._v(" "),
            _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("使用帮助")])]),
            _vm._v(" "),
            _c("li", [_c("a", { attrs: { href: "#" } }, [_vm._v("设为首页")])]),
            _vm._v(" "),
            _c("li", { staticStyle: { border: "0" } }, [
              _c("a", { attrs: { href: "#" } }, [_vm._v("加入收藏")])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sy_copy_text" }, [
          _vm._v("版权所有 © 十堰医学会"),
          _c(
            "div",
            {
              staticStyle: {
                "line-height": "24px",
                "margin-top": "10px",
                "text-align": "center",
                color: "#666",
                "font-size": "12px"
              }
            },
            [
              _c(
                "a",
                {
                  staticStyle: { "padding-right": "20px", color: "#666" },
                  attrs: { href: "https://beian.miit.gov.cn", target: "_blank" }
                },
                [_vm._v("京ICP备12019974号")]
              ),
              _c(
                "span",
                { staticStyle: { "padding-right": "15px", color: "#666" } },
                [_vm._v("经营许可证编号京B2-20180132")]
              ),
              _c(
                "a",
                {
                  staticStyle: {
                    position: "relative",
                    "padding-left": "23px",
                    color: "#666"
                  },
                  attrs: {
                    target: "_blank",
                    href:
                      "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025121"
                  }
                },
                [
                  _c("img", {
                    staticStyle: {
                      width: "20px",
                      height: "20px",
                      position: "absolute",
                      left: "0px",
                      top: "0px"
                    },
                    attrs: {
                      src:
                        "https://source.yiboshi.com/public/img/%E5%A4%87%E6%A1%88%E5%9B%BE%E6%A0%87.png"
                    }
                  }),
                  _vm._v("京公网安备  11010802025121号 ")
                ]
              )
            ]
          ),
          _vm._v("\n    CopyRight By www.shiyanma.gov.cn 2009 ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "sy_copy_other" }, [
          _c(
            "a",
            {
              attrs: {
                target: "_blank",
                href:
                  "http://bszs.conac.cn/sitename?method=show&id=13B9368C52C86DEBE053022819AC1590"
              }
            },
            [
              _c("img", {
                attrs: {
                  src: "http://dcs.conac.cn/image/blue.png",
                  alt: "政务和公益机构标识证书"
                }
              })
            ]
          )
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-567d7614", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567d7614","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer1.vue
// module id = bNlY
// module chunks = 1